export function getMealTypesArray(data) {
  const res = Object.values(data)
    .flatMap((item) => Object.values(item))
    .map((item) => ({
      ...item,

      meals: Object.values(item.meals).map((meal) => ({
        ...meal,

        allergensGroups: Object.values(meal.allergensGroups)?.map((allergensGroup) => ({
          ...allergensGroup,
          allergens: Object.values(allergensGroup.allergens),
        })),

        allergensGroupsNames: Object.values(meal.allergensGroupsNames),
        allergensGroupsNumbers: Object.values(meal.allergensGroupsNumbers),

        portionSizes: Object.values(meal.portionSizes)?.map((portionSize) => ({
          ...portionSize,

          ingredients: Object.values(portionSize.ingredients).filter(
            (item) => !isEmptyObject(item),
          ),
          nutrition: isEmptyObject(portionSize.nutrition) ? null : portionSize.nutrition,
        })),
      })),
    }));

  return res;
}

function isEmptyObject(obj) {
  return Object.values(obj).every((value) => !value);
}

export function getMealsMenuWithFilteredInstitutions(data, userLocations = []) {
  if (!userLocations.length || !data.institutions?.length) {
    return data;
  }

  return {
    ...data,
    institutions: data.institutions.filter((institution) => userLocations.includes(institution.id)),
  };
}

export function getUserAllergensIds(user) {
  return user.allergies?.map((allergy) => allergy?.id || allergy);
}

export function getUserAllergensNames(user) {
  return user.allergies?.map((allergy) => allergy?.name || allergy);
}

export function addSubjectAllergensToMealTypes(mealTypes, subjectAllergensIds) {
  return mealTypes.map((mealType) => ({
    ...mealType,

    meals: mealType.meals.map((meal) => {
      return {
        ...meal,

        allergensGroups: meal.allergensGroups?.map((allergensGroup) => {
          return {
            ...allergensGroup,

            allergensToHighlight: allergensGroup.allergens.filter((allergen) =>
              subjectAllergensIds.includes(allergen.id),
            ),
          };
        }),
      };
    }),
  }));
}
